// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3iN3j","list":"BalanceDue_list__2uDOk","listRow":"BalanceDue_listRow__37fr8","total":"BalanceDue_total__2H_s4"};